import React, { type ReactElement } from 'react';

type Props = {
	renderChartDragLayer?: () => ReactElement | null;
	renderOverlayButton?: () => ReactElement | null;
};

const RoadmapChartOverlay = ({
	renderChartDragLayer = () => null,
	renderOverlayButton = () => null,
}: Props) => (
	<>
		{renderOverlayButton()}
		{renderChartDragLayer()}
	</>
);

export { RoadmapChartOverlay };
export { RoadmapChartDragLayer } from './drag-layer';
export { RoadmapTodayButton } from './today-button';
export { RoadmapTimelineMode } from './timeline-mode';

export type { DragLayerMeta } from './drag-layer/types';
